export default __webpack_public_path__ + "static/media/litho-demo-dentist.587b14ef.jpg";